// Solution pour permettre aux titres de produits de s'afficher sur plusieurs lignes
document.addEventListener("DOMContentLoaded", () => {
  // Fonction pour ajuster les titres de produits
  function fixProductTitles() {
    try {
      // Cibler les conteneurs split-words dans les titres de produits
      const productTitleContainers = document.querySelectorAll(
        ".product-title-sm .split-words, .product__title .split-words",
      )

      if (productTitleContainers.length > 0) {
        console.log("Conteneurs de titres de produits trouvés:", productTitleContainers.length)

        productTitleContainers.forEach((container) => {
          // Permettre au conteneur de s'afficher sur plusieurs lignes
          container.style.display = "block"
          container.style.width = "100%"
          container.style.whiteSpace = "normal"
          container.style.lineHeight = "1.3"

          // Ajuster les mots à l'intérieur
          const words = container.querySelectorAll(".word")
          words.forEach((word) => {
            word.style.display = "inline-block"
            word.style.marginRight = "0.2em"
            word.style.marginBottom = "0.1em"

            // Cibler également l'élément animate-element à l'intérieur
            const animateElement = word.querySelector("animate-element")
            if (animateElement) {
              animateElement.style.display = "inline-block"
            }
          })
        })
      }
    } catch (error) {
      console.error("Erreur lors de la correction des titres:", error)
    }
  }

  // Exécuter immédiatement
  fixProductTitles()

  // Exécuter après un court délai pour s'assurer que tout est chargé
  setTimeout(fixProductTitles, 500)

  // Exécuter après le chargement complet de la page
  window.addEventListener("load", () => {
    fixProductTitles()
  })
})
